/**
 * The phone app's words for the day's work (piece 35, *Calendar, check-in and
 * to-dos (batch CR2)*; decisions 4410, 4440): Check In and Check Out on a Site,
 * My Day (its week strip, month grid and agenda since row T2732, decision
 * 5370), Add Event and its cancel, and the to-dos' Done, Snooze and Dismiss,
 * kept beside the other batches' and spread into the one string lookup. A word
 * the web already says, such as + Check In, Check out, the event's Title, Start
 * and End, the cancel's question or the to-dos' own buttons, is read from the
 * web's own key and is not repeated here.
 */
export const CRM_DAY_STRINGS = {
  'mobile.day.title': 'My Day',
  'mobile.day.today': 'Today',
  'mobile.day.tomorrow': 'Tomorrow',
  'mobile.day.noEvents': 'No events',
  // Decision 13030 (row T3858): Request Time Off under My Day, the web's request on the phone.
  'mobile.timeOff.unsent': 'This request needs signal on this phone. Try again when it has one.',
  'mobile.timeOff.needsSignal': 'Your plans and balances are read once with signal. Open this again when the phone has one.',
  'mobile.timeOff.decidedOnWeb': 'Your manager approves or rejects it on the web, and approved time off appears on this calendar.',
  'mobile.day.showMonth': 'Show the month',
  'mobile.day.showWeek': 'Show the week',
  'mobile.day.cancelEvent': 'Cancel Event',
  'mobile.day.cancelTitle': 'Cancel this event?',
  'mobile.day.cancelBody': 'The event comes off the calendar and its attendees keep the record of it. You can reinstate it afterwards.',
  'mobile.day.keepEvent': 'Keep It',
  'mobile.day.occurrence': 'Only this occurrence is canceled. A whole series is canceled on the web.',
  'mobile.day.unreachable': 'Nothing was changed, because the server did not answer. Check the connection, then try again.',
  'mobile.day.dayProblem': 'Type the day as year, month and day, such as 2026-10-15.',
  'mobile.checkIn.checkedIn': 'Checked in.',
  'mobile.checkIn.checkedOut': 'Checked out.',
  'mobile.checkIn.denied': 'Location permission was refused. Allow it in the phone’s Settings for this app to record where you check in.',
  'mobile.checkIn.timeout': 'The phone took too long to find where you are.',
  'mobile.checkIn.unavailable': 'The phone could not tell where you are.',
  'mobile.event.day': 'Day',
  'mobile.event.timeHint': 'Hour and minute on a 24-hour clock, such as 14:30.',
  'mobile.event.webFields': 'The phone sets the title, the day and the times. The place, the attendees, the repeat and the reminder are set on the web.',
  'mobile.event.required': 'A title, a day, a start and an end are required.',
  'mobile.event.timeProblem': 'Type each time as hour and minute, such as 14:30.',
  'mobile.event.orderProblem': 'The end comes after the start.',
  'mobile.event.saved': 'The event is saved.',
} as const;
